import { gql } from "@apollo/client";

// Main application query
export const portalApplication = gql`
  query portalApplication($id: ID) {
    portalApplication(id: $id) {
      id
      short_id
      unique_id
      status
      first_name
      last_name
      email
      phone
      address
      city
      state
      zip
      bank {
        id
        name
        logo
        url
        account_type
        last_four
        is_active
        cc_exp
      }
      plan {
        type
        amount
        service_percent
        monthly_fees
        debt_amount
        months
        start_date
      }
    }
  }
`;

// Credit reports query
export const portalCreditReport = gql`
  query portalCreditReport($application_id: ID) {
    portalCreditReport(application_id: $application_id) {
      applicant_report {
        id
        issuer
        report
        pdf_url
        createdAt
      }
      co_applicant_report {
        id
        issuer
        report
        pdf_url
        createdAt
      }
      payment
      balance
      limit
    }
  }
`;

// Payments query
export const portalPayments = gql`
  query portalPayments($id: ID) {
    portalPayments(id: $id) {
      data {
        id
        short_id
        status
        order
        amount
        next_attempt
        first_attempt
        last_attempt
      }
      total
    }
  }
`;

// Tradelines/Accounts query
export const portalTradelines = gql`
  query portalTradelines($id: ID) {
    portalTradelines(id: $id) {
      tradelines {
        id
        selected
        tradeline {
          accountNumber
          accountType
          accountTypeText
          balanceAmount
          scheduledPaymentAmount
          creditLimitAmount
          accountStatus
          customerName
          openOrClosed
        }
      }
      selected
      total
      payment
      balance
      limit
    }
  }
`;

// Documents query
export const portalDocuments = gql`
  query portalDocuments($application_id: ID) {
    portalDocuments(application_id: $application_id) {
      id
      name
      type
      fileType
      size
      url
      added_by_client
      createdAt
    }
  }
`;

// Budget query
export const getBudget = gql`
  query getBudget($application_id: ID) {
    getBudget(application_id: $application_id) {
      id
      items {
        name
        category
        type
        value
      }
      createdAt
      updatedAt
    }
  }
`;

// Budget mutation
export const saveBudget = gql`
  mutation saveBudget($application_id: ID, $items: [BudgetItemInput]) {
    saveBudget(application_id: $application_id, items: $items)
  }
`;
